import {
	Component,
	OnInit,
	Input,
	ViewEncapsulation,
	ViewChild,
	EventEmitter,
	Output,
	ChangeDetectorRef,
} from "@angular/core";
import { ControlContainer, NgForm, NgControl } from "@angular/forms";
import { CommonHelper } from "../../../core/_config/common.helper";
import { CustomValidators } from "ngx-custom-validators";
import { LanguageSelectorService } from "../../../views/partials/layout/topbar/language-selector/language-selector.service";
import { formatDate } from '@angular/common';
@Component({
	selector: "hec-input",
	templateUrl: "./hec-input.component.html",
	styleUrls: ["./hec-input.component.scss"],
	encapsulation: ViewEncapsulation.None,
	viewProviders: [
		{
			provide: ControlContainer,
			useExisting: NgForm,
		},
	],
})
export class HecInputComponent implements OnInit {
	@ViewChild("input", { static: false }) input: NgControl;
	@Input("") placement: string;
	@Input("") toolsTip: string;
	@Input("") tooltip: string;
	@Input("") toolIcon: boolean = false;
	@Input("") toolText: boolean = false;
	@Input("") displayName: string;
	@Input("") config: any;
	@Input("") name: string;
	@Input("") type: string;
	@Input("") options: any;
	@Input("") disabledOptions: any;
	@Input("") value: any;
	@Input("") rows: number;
	@Input("") maxlength: string;
	@Input("") minlength: string;
	@Input("") mode: string;
	@Input("") readonly: boolean = false;
	@Input("") required: boolean = false;
	@Input("") disabled: boolean;
	@Input("") placeholder: string;
	@Input("") min: any;
	@Input("") max: number = 5;
	@Input("") hint: string;
	@Input() showMinStampValidation: boolean = false;
	@Input("") pattern: string;
	@Input("") ppattern: string;
	@Input("") checked: boolean = false;
	@Input("") showHint: boolean = false;
	@Input("") hintText: string = null;
	@Input("") numberOptPatternMsg: string;
	@Input("") mindate: Date;
	@Input("") radioPlaceholder1: string;
	@Input("") maxdate: Date;
	@Input("") id: any;
	@Input("") patternForDecimal: string;
	@Input("") copyAllowed: boolean;
	@Input("") toolTips: string;
	// My Custom Date Controls
	@Input("") minDate: string =
		CommonHelper.get100YrOldDateInFormat("YYYY-MM-DD");
	// By Default max date is set to today
	@Input("") maxDate: string = CommonHelper.getDateInFormat("YYYY-MM-DD");
	// My Radio Controls
	@Input("") radioDisplayValue1: string;
	@Input("") radioDisplayValue2: string;
	@Input("") radioValue: boolean;
	@Input("") dirValue: string;
	@Input("") mustMatch: HecInputComponent;
	@Input("") equalTo: HecInputComponent;
	@Input("") equalToErrorMessage: string;
	@Input("") greaterThan: HecInputComponent;
	@Input("") greaterThanErrorMessage: string;
	@Input("") greaterThanOrEqual: HecInputComponent;
	@Input("") greaterThanOrEqualErrorMessage: string;
	@Input("") lessThan: HecInputComponent;
	@Input("") lessThanErrorMessage: string;
	@Input("") lessThanOrEqual: HecInputComponent;
	@Input("") lessThanOrEqualErrorMessage: string;
	@Input("") disableDate: boolean = false;
	@Input("") searchCtrl: string = "";
	@Output() onBlur = new EventEmitter();
	@Output() selectChanged = new EventEmitter();
	@Output() textChanged = new EventEmitter();
	@Output() dateChanged = new EventEmitter();
	@Output() fieldChanged = new EventEmitter();
	@Output() loadMinDate = new EventEmitter();
	@Output() checkBoxChanged = new EventEmitter();
	@Output() radioButtonChanged = new EventEmitter();
	public changeDir: boolean;
	public MOBILE_REGEX = CommonHelper.MOBILE_REGEX;
	public PHONE_REGEX = CommonHelper.PHONE_REGEX;
	public EMAIL_REGEX = CommonHelper.EMAIL_REGEX;
	public SECONDARY_EMAIL_REGEX = CommonHelper.SECONDARY_EMAIL_REGEX
	public CNIC_REGEX = CommonHelper.CNIC_REGEX;
	public passwordHide = true;
	public num: number = 12345678901;
	constructor(
		private change: ChangeDetectorRef,
		private languageSelector: LanguageSelectorService
	) {
		this.languageSelector.isRtl.subscribe((res) => {
			console.log(res);
			this.changeDirection();
		});
		if (localStorage.getItem("language") == "pk") {
			this.changeDir = true;
		} else {
			this.changeDir = false;
		}
	}

	ngOnInit() {
		this.setDefaultFieldLengths();
		// Default Number Pattern
		this.pattern = this.pattern || "[0-9]*";

		this.config = {
			displayKey: "codeValue",
			search: true,
			searchPlaceholder: "Search",
			placeholder: "Select One",
			noResultsFound: "No Matches found!",
			searchOnKey: "codeValue",
		};

		if (
			(this.equalTo ||
				this.greaterThan ||
				this.greaterThanOrEqual ||
				this.lessThan ||
				this.lessThanOrEqual) &&
			!this.mode
		) {
			console.error(
				` Control: ${this.name}\nError: mode attribute not found. `
			);
			return;
		}

		if (
			(this.equalTo ||
				this.greaterThan ||
				this.greaterThanOrEqual ||
				this.lessThan ||
				this.lessThanOrEqual) &&
			this.mode &&
			this.mode.toLowerCase() !== "compare"
		) {
			console.error(
				` Control: ${this.name}\nError: mode value should be 'compare' for ['equalTo', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'] validations.
        `
			);
			return;
		}

		if (
			!this.equalTo &&
			!this.greaterThan &&
			!this.greaterThanOrEqual &&
			!this.lessThan &&
			!this.lessThanOrEqual &&
			this.mode
		) {
			console.error(
				` Control: ${this.name}\nError: mode attribute should be use with ['equalTo', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'] validations.
        `
			);
			return;
		}

		if (
			(this.greaterThan ||
				this.greaterThanOrEqual ||
				this.lessThan ||
				this.lessThanOrEqual) &&
			this.type != "number" &&
			this.type != "date" &&
			this.type != "dateOpt"
		) {
			console.error(
				` Control: ${this.name}\nError: ['greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'] validations should be use with type="number" and type="date".
        `
			);
			return;
		}
	}

	public changeDirection() {
		this.changeDir = !this.changeDir;
	}

	setDefaultFieldLengths() {
		if (this.type == "text") {
			this.maxlength = this.maxlength || "50";
		}

		if (this.type == "textarea") {
			this.maxlength = this.maxlength || "500";
		}

		if (this.type == "number" || this.type == "numberOpt") {
			this.maxlength = this.maxlength || "15";
		}

		if (this.type == "decimalNumber" || this.type == "decimalNumberOpt") {
			this.maxlength = this.maxlength || "15";
		}

		if (this.type == "email" || this.type == "emailOpt") {
			this.maxlength = this.maxlength || "50";
		}

		if (this.type == "cell" || this.type == "cellOpt") {
			this.maxlength = this.maxlength || "11";
		}

		if (this.type == "phone" || this.type == "phoneOpt") {
			this.maxlength = this.maxlength || "11";
		}
	}

	ngAfterViewInit() {
		if (this.mode && this.mode.toLowerCase() == "compare" && this.equalTo) {
			this.input.control.setValidators([
				CustomValidators.equalTo(this.equalTo.input.control),
			]);
		}
		if (
			this.type &&
			(this.type == "date" ||
				this.type == "dateOpt" ||
				this.type == "ngbDate")
		) {
			if (
				this.mode &&
				this.mode.toLowerCase() == "compare" &&
				this.greaterThanOrEqual
			) {
				this.input.control.setValidators([
					CustomValidators.minDate(
						this.greaterThanOrEqual.input.control
					),
				]);
			}
			if (
				this.mode &&
				this.mode.toLowerCase() == "compare" &&
				this.lessThanOrEqual
			) {
				this.input.control.setValidators([
					CustomValidators.maxDate(
						this.lessThanOrEqual.input.control
					),
				]);
			}
		}
		this.change.detectChanges();
	}

	blur(event: FocusEvent) {
		this.onBlur.emit();
	}

	keyPress(event: any) {
		const pattern = /[0-9\+\ ]/;

		if (!pattern.test(event.key)) {
			event.preventDefault();
		}
	}

	selectEvent(event) {
		this.selectChanged.emit(event.value);
	}

	textChangedEvent(event) {
		this.textChanged.emit(event);
	}

	fieldValue(event) {
		if (event.key == "e") event.preventDefault();
	}

	dateChangedEvent(event) {
		this.dateChanged.emit(event.target.value);
	}

	radioChangedEvent(event) {
		this.radioButtonChanged.emit(event);
	}

	checkBoxEvent(event) {
		this.checkBoxChanged.emit(event.checked);
	}

	dateNgModelChangedEvent(event) {
		let userSelectedDate = new Date(event);
		let maxDate = new Date(this.maxDate) || null;
		let minDate = new Date(this.minDate) || null;
		//console.log(minDate,userSelectedDate, String(minDate) > String(userSelectedDate))
		// if (String(minDate) > String(userSelectedDate)) {
		// 	this.greaterThanOrEqualErrorMessage =
		// 		"End date should be greater than Start date";
		// 	this.input.control.setErrors({ minDate: true });
		// 	return;
		// } else if (minDate != userSelectedDate) {
		// 	this.input.control.setErrors(null);
		// }

		// if (formatDate(minDate,'yyyy-MM-dd','en_US') > formatDate(userSelectedDate,'yyyy-MM-dd','en_US')) 
		// {
		// console.log('---Fromdate is greater----');
		// this.greaterThanOrEqualErrorMessage =
		// 	"End date should be greater than Start date";
		// 	this.input.control.setErrors({ minDate: true });
		// 	return;
		// }
		// else if (minDate != userSelectedDate) {
		// 		this.input.control.setErrors(null);
		// 	}
		this.dateChanged.emit(event);
	}
}
